import type { PropsWithChildren } from 'react'
import { observer } from 'mobx-react-lite'
import InfiniteScroll from 'react-infinite-scroll-component'
import styled from 'styled-components'

import type { BaseListParams } from '../../store/subStore'

interface InfinityContentProps {
  length: number
  hasMore: boolean
  listParams?: BaseListParams
  reverse?: boolean
  onScroll: () => void
}

export const InfinityContent = observer(
  ({ children, length, hasMore, reverse, onScroll }: PropsWithChildren<InfinityContentProps>) => {
    if (reverse) {
      return (
        <ReverseContainer>
          <InfiniteScroll
            dataLength={length}
            hasMore={hasMore}
            inverse={true}
            loader={null}
            scrollableTarget="scrollableDiv"
            next={onScroll}
          >
            {children}
          </InfiniteScroll>
        </ReverseContainer>
      )
    }

    return (
      <InfiniteScroll
        dataLength={length}
        hasMore={hasMore}
        loader={null}
        scrollableTarget="scrollableDiv"
        next={onScroll}
      >
        {children}
      </InfiniteScroll>
    )
  },
)

const ReverseContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  overflow-y: auto;
`
